export const environment = {
  production: false,

  // **** DEV CONFIG ****
  firebaseConfig: {
    apiKey: 'AIzaSyAosIT7R03KzGf_WyXhEvqrk0ByypsRYXc',
    authDomain: 'pegadagourmet-dev.firebaseapp.com',
    databaseURL: 'https://pegadagourmet-dev.firebaseio.com',
    projectId: 'pegadagourmet-dev',
    storageBucket: 'pegadagourmet-dev.appspot.com',
    messagingSenderId: '14348986610'
  },
  defaultUrl: 'https://pegadagourmet-dev.firebaseapp.com'

  // gender: [
  //   new Gender({ uuid: null, name: 'Selecione um gênero' }),
  //   new Gender({ uuid: 'f', name: 'Fêmea' }),
  //   new Gender({ uuid: 'm', name: 'Macho' }),
  // ],
  // species: [
  //   new Species({ uuid: 'canino', name: 'Canino' }),
  //   new Species({ uuid: 'felino', name: 'Felino' }),
  // ],
  // pelage: [
  //   new Pelage({ uuid: 'sp', name: 'Sem Pêlo' }),
  //   new Pelage({ uuid: 'pc', name: 'Pêlo Curto' }),
  //   new Pelage({ uuid: 'pl', name: 'Pêlo Longo' }),
  //   new Pelage({ uuid: 'pd', name: 'Pêlo Duro' }),
  // ]
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
